/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'us-west-2',
  aws_cloud_logic_custom: [
    {
      name: 'AmplifyAuth',
      endpoint: 'https://4i5kmcwbwh.execute-api.us-west-2.amazonaws.com/stage',
      region: 'us-west-2',
    },
  ],
  aws_appsync_graphqlEndpoint: 'https://6ieod6lelnemdnjv4kcbotxvdy.appsync-api.us-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-fakeApiId123456',
  aws_cognito_identity_pool_id: 'us-west-2:6845fb1e-4017-4b73-88a9-6238ee49289c',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_kRygADGPh',
  aws_user_pools_web_client_id: '2gkkn3hj5j0olj7qhugkc2d4pu',
  oauth: {},
  aws_cognito_login_mechanisms: ['PHONE_NUMBER'],
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['PHONE_NUMBER'],
  aws_cognito_username_attributes: ['PHONE_NUMBER'],
  aws_cognito_social_providers: [],
};

export default awsmobile;
